/**
 * @desc undefined
 */
import { SendCodeResult, SendCodeOption } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SendSmsCodeParameter = SendCodeOption

const method = 'POST'
const url = '/nexus/sms/code/send'

export const sendSmsCodeApi = (
  data?: SendSmsCodeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<SendCodeResult>({
    method,
    url,
    data,
    ...config
  })
}

sendSmsCodeApi.method = method
sendSmsCodeApi.url = url
